import axios from "@/api/axiosInstance";
import {
  AdoptionConnectionsResult,
  GetAdoptionConnectionsRequest,
  GetAdoptionConnectionsResponse,
} from "./types";

export const getAdoptionConnections = async (
  params: GetAdoptionConnectionsRequest,
  signal?: AbortSignal,
): Promise<AdoptionConnectionsResult> => {
  const response = await axios.get<GetAdoptionConnectionsResponse>(
    "/api/private/admin/data-connector-adoption/connections",
    { params, signal },
  );
  return {
    connections: response.data.data.connections,
    totalCount: response.data.meta?.totalCount ?? 0,
  };
};
